import { render, staticRenderFns } from "./CalendarFlightDetails.vue?vue&type=template&id=db28383c&scoped=true&"
import script from "./CalendarFlightDetails.vue?vue&type=script&lang=js&"
export * from "./CalendarFlightDetails.vue?vue&type=script&lang=js&"
import style0 from "./CalendarFlightDetails.vue?vue&type=style&index=0&id=db28383c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db28383c",
  null
  
)

export default component.exports